const columns = [
  {
    title: "姓名",
    key: "user_cn_name",
  },
  {
    title: "用户名",
    key: "crt_bk_user",
  },
  {
    title: "申请时间",
    key: "crt_bk_time",
  },
  {
    title: "部门名称",
    key: "dept_cn_name",
  },
  {
    title: "操作",
    slot: "iconfont",
    iconClass: [
      {
        name: "同意",
        code: "start",
        status: 2,
        type: "success",
        size: "small",
        Pname: "Edit",
      },
      {
        name: "拒绝",
        code: "end",
        status: 2,
        type: "default",
        size: "small",
        Pname: "Edit",
      },
    ],
  },
];

export default columns;
